import {
	Component,
	Input,
	OnInit,
	ChangeDetectionStrategy,
} from "@angular/core"
import { COMMON_IMPORTS } from "../common-imports"
import { Modalable } from "@app/Modalable"
import { CancelBtnComponent } from "@app/utils/utils.component"
import { LangValPipe } from "@app/utils/lang-val.pipe"

@Component({
	selector: "app-copy-link",
	imports: [COMMON_IMPORTS, CancelBtnComponent, LangValPipe],
	changeDetection: ChangeDetectionStrategy.Eager,
	template: `
		<div class="mt-3">
			<p>My-Cliniq מזמינה אתכם למבצע.</p>
			<p>בהזמנת חבר.ה תקבלו שתיכן חודש שימוש נוסף חינם.</p>
			<p>(המוזמן מיד, המזמין לאחר שהמוזמן מתחיל לשלם).</p>
			<p></p>
			<p>להזמנת חבר.ה יש לקבל קישור כך:</p>
			<p>לפתוח את התפריט האישי (למעלה משמאל)/ לבחור: קישור להזמנת חברים</p>
			<p>לבחור : כפתור "קישור להזמנת חברים"</p>
			<p>לשלוח את הקישור (ע"י Ctrl-V או עי Paste) לחבר.ה.</p>
			<p>הקישור מפנה אותו.ה להרשמה.</p>
			<p>הרשמה דרך הקישור תזכה אתכם, אוטומטית בחודש נוסף חינם</p>
			<p></p>
			<p>למתקשים, פשוט הודיעו לנו, את מי הזמנתם ותזכו להטבה.</p>
		</div>
		<!--
		<div
			class="row"
			style="min-height:120px;font-size: 16px;margin-top: 50px"
			[titleLang]="langText"
		>
			<div class="col-12">
				{{ langText | langVal }}
				<button
					class="btn btn-icon"
					(click)="copy()"
					titleLang="copy_link"
					icon="copy"
				></button>
			</div>
		</div>
		-->

		<div class="modal-btns">
			<app-cancel-btn (click)="onClose.emit()" />
			<button
				class="btn btn-primary"
				(click)="copy(); onClose.emit(true)"
				titleLang="copy_link"
			>
				{{ "affiliate_link" | langVal }}
			</button>
		</div>
	`,
})
export class CopyLinkComponent extends Modalable {
	@Input() link: string = ""

	copy() {
		navigator.clipboard.writeText(this.link)
		this.modalService.openToast("copy_link")
	}
}
